/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscLunartimeRequest = {
  ts?: string | undefined;
  timezone?: string | undefined;
};

export const GetMiscLunartimeRequest$zodSchema: z.ZodType<
  GetMiscLunartimeRequest
> = z.object({
  timezone: z.string().describe(
    "时区名称。支持 IANA 时区（如 Asia/Shanghai）和别名（Shanghai、Beijing）。默认 Asia/Shanghai。",
  ).optional(),
  ts: z.string().describe(
    "Unix 时间戳，支持 10 位秒级或 13 位毫秒级。不传则默认当前时间。",
  ).optional(),
});

/**
 * 请求参数错误。`timezone` 非法时返回 `invalid timezone: xxx`，`ts` 非法时返回 `invalid timestamp: xxx`。
 */
export type GetMiscLunartimeBadRequestResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
};

export const GetMiscLunartimeBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscLunartimeBadRequestResponseBody
> = z.object({
  code: z.int().optional(),
  message: z.string().optional(),
}).describe(
  "请求参数错误。`timezone` 非法时返回 `invalid timezone: xxx`，`ts` 非法时返回 `invalid timestamp: xxx`。",
);

/**
 * 万年历查询结果。
 */
export type GetMiscLunartimeData = {
  query_timestamp?: string | undefined;
  query_timezone?: string | undefined;
  timezone?: string | undefined;
  datetime?: string | undefined;
  datetime_rfc3339?: string | undefined;
  timestamp_unix?: number | undefined;
  weekday?: string | undefined;
  weekday_cn?: string | undefined;
  lunar_year?: number | undefined;
  lunar_month?: number | undefined;
  lunar_day?: number | undefined;
  is_leap_month?: boolean | undefined;
  lunar_year_cn?: string | undefined;
  lunar_month_cn?: string | undefined;
  lunar_day_cn?: string | undefined;
  ganzhi_year?: string | undefined;
  ganzhi_month?: string | undefined;
  ganzhi_day?: string | undefined;
  zodiac?: string | undefined;
  solar_term?: string | undefined;
  lunar_festivals?: Array<string> | undefined;
  solar_festivals?: Array<string> | undefined;
};

export const GetMiscLunartimeData$zodSchema: z.ZodType<GetMiscLunartimeData> = z
  .object({
    datetime: z.string().optional(),
    datetime_rfc3339: z.string().optional(),
    ganzhi_day: z.string().optional(),
    ganzhi_month: z.string().optional(),
    ganzhi_year: z.string().optional(),
    is_leap_month: z.boolean().optional(),
    lunar_day: z.int().optional(),
    lunar_day_cn: z.string().optional(),
    lunar_festivals: z.array(z.string()).optional(),
    lunar_month: z.int().optional(),
    lunar_month_cn: z.string().optional(),
    lunar_year: z.int().optional(),
    lunar_year_cn: z.string().optional(),
    query_timestamp: z.string().optional(),
    query_timezone: z.string().optional(),
    solar_festivals: z.array(z.string()).optional(),
    solar_term: z.string().optional(),
    timestamp_unix: z.int().optional(),
    timezone: z.string().optional(),
    weekday: z.string().optional(),
    weekday_cn: z.string().optional(),
    zodiac: z.string().optional(),
  }).describe("万年历查询结果。");

/**
 * 查询成功，返回指定时间和时区下的农历信息。
 */
export type GetMiscLunartimeResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
  data?: GetMiscLunartimeData | undefined;
};

export const GetMiscLunartimeResponseBody$zodSchema: z.ZodType<
  GetMiscLunartimeResponseBody
> = z.object({
  code: z.int().optional(),
  data: z.lazy(() => GetMiscLunartimeData$zodSchema).optional(),
  message: z.string().optional(),
}).describe("查询成功，返回指定时间和时区下的农历信息。");

export type GetMiscLunartimeResponse =
  | GetMiscLunartimeResponseBody
  | GetMiscLunartimeBadRequestResponseBody;

export const GetMiscLunartimeResponse$zodSchema: z.ZodType<
  GetMiscLunartimeResponse
> = z.union([
  z.lazy(() => GetMiscLunartimeResponseBody$zodSchema),
  z.lazy(() => GetMiscLunartimeBadRequestResponseBody$zodSchema),
]);
